export default __webpack_public_path__ + "static/media/callShopInfo.e5434403.png";